const YoutubeIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      fill="none"
      viewBox="0 0 46 46"
      className={className}
    >
      <g clipPath="url(#clip0_741_5961)">
        <path
          fill="currentColor"
          d="M35.5 16.58a3.198 3.198 0 00-2.267-2.249c-2-.531-10.018-.531-10.018-.531s-8.019 0-10.018.531a3.198 3.198 0 00-2.267 2.249c-.536 1.983-.536 6.12-.536 6.12s0 4.139.536 6.122c.295 1.094 1.163 1.92 2.267 2.212 2 .532 10.018.532 10.018.532s8.018 0 10.018-.532c1.103-.292 1.972-1.118 2.267-2.212.536-1.983.536-6.121.536-6.121s0-4.138-.536-6.121zm-14.908 9.878v-7.514l6.702 3.757-6.702 3.757z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_741_5961">
          <path
            fill="#fff"
            d="M0 0H25.729V17.765H0z"
            transform="translate(10.35 13.8)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export default YoutubeIcon;
